export default function ListaPagos() {
    return (
        <div>
            <h1>ListaPagos</h1>
        </div>
    )
}
